import React, { useContext } from "react";
import { AuthApiReturnType } from "../api/useAuth.api";
import { catgoryApiReturnType } from "../api/users.api";

const PrivateContext = React.createContext<any>({});

type PrivateProviderProps = {
  data: any;
  children: React.ReactNode;
};

interface PrivateContextInterface {
  auth: AuthApiReturnType;
  getChangeUsers: catgoryApiReturnType;
}

export const PrivateProvider: React.FC<PrivateProviderProps> = ({
  data,
  children,
}) => {
  return (
    <PrivateContext.Provider value={data || {}}>
      {children}
    </PrivateContext.Provider>
  );
};

export const usePrivateContext = () => {
  const privateContextValue: PrivateContextInterface =
    useContext(PrivateContext);
  return { ...privateContextValue };
};
